// Flow types automatically removed

import { createContext } from 'react';

/**
 * Used as the default implementations of the react context functions. It will
 * always error since it expects there to be a QueryParamsProvider.
 */
function initialContextFn() {
    console.error(
        'Attempt to render a <QueryParamsConsumer> without a <QueryParamsProvider> ' +
            'parent found. Make sure to add <QueryParamsProvider> to have this work.'
    );
}

const initialQueryParamContext = {
    getQueryParam: initialContextFn,
    setQueryParam: initialContextFn,
    mergeQueryParamsObj: initialContextFn,
    reset: initialContextFn,
};
export const { Provider, Consumer } = createContext(initialQueryParamContext);
